<template>
    <UiKPI
        :title="data.title"
        :value="data.value"
        :period="data.period"
        :href="data.url"
        :loading="loading"
    />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import axios from 'axios';

interface Props {
    settings: Record<string, unknown>;
    slug: string;
}

interface KPIData {
    title: string;
    period: string | null;
    value: string | number;
    url: string | null;
}

const props = defineProps<Props>();

const loading = ref(true);
const data = ref<KPIData>({
    title: '',
    period: null,
    value: '',
    url: null,
});

const load = () => {
    loading.value = true;

    axios
        .get(route('admin.dashboards.widgets.data', { slug: props.slug }))
        .then(({ data: response }) => {
            data.value = response;
        })
        .finally(() => {
            loading.value = false;
        });
};

onMounted(() => {
    load();
});
</script>
